import React from 'react'
import { func } from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Form from '../../components/Form'

import * as Style from './Main.style'

export default function Main({ handleForm, setFunnelStage }) {
  return (
    <Style.MainWrapper>
      <Style.Container>
        <Style.Title>
          <FormattedMessage id="smb_acquisition_company_info.page.title" />
        </Style.Title>

        <Style.Subtitle>
          <FormattedMessage id="smb_acquisition_company_info.page.subtitle" />
        </Style.Subtitle>

        <Form onSubmit={handleForm} setFunnelStage={setFunnelStage} />
      </Style.Container>
    </Style.MainWrapper>
  )
}

Main.propTypes = {
  handleForm: func.isRequired,
  setFunnelStage: func.isRequired,
}
